// extracted by mini-css-extract-plugin
module.exports = {"EmptyHeader":"EmptyHeader_EmptyHeader__mDoJp","mainMenu":"EmptyHeader_mainMenu__5sbcP"};